import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { JobsServiceProvider } from '../../api/jobs'

const JobsService = JobsServiceProvider()
const nameJob = 'getJobTypes'

export default () => (asyncAction(
  nameJob,
  JobsService.getJobTypes
))

export const reducer = asyncReducer(nameJob)
export const selector = asyncSelector(nameJob)



// WEBPACK FOOTER //
// ./src/store/jobs/getJobTypes.js